import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconNote = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="m22 10-6-6H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99l16-.01c1.1 0 2-.89 2-1.99zm-7-4.5 5.5 5.5H15z" />
  </SvgIcon>
);

export default IconNote;



// WEBPACK FOOTER //
// ./src/components/icons/IconNote.js